<h2 mat-dialog-title>
    Journal Entry Templates
    <ng-container *ngIf="selectedTemplate">
        - {{selectedTemplate.TemplateName}}
    </ng-container>
</h2>

<mat-dialog-content>
    <mat-progress-bar *ngIf="!isLoaded" mode="indeterminate"></mat-progress-bar>

    <ng-container *ngIf="isLoaded">
        <form [formGroup]="tableFormGroup">
            <table mat-table fxFill [dataSource]="tableData" formArrayName="rows">

                <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef>Select</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <div [formGroupName]="i+1">
                            <lgd-checkbox controlName="selected">
                            </lgd-checkbox>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="TemplateName">
                    <th mat-header-cell *matHeaderCellDef>
                        <ng-container formGroupName="0">
                            <lgd-text controlName="templateNameFilter" label="Name">
                            </lgd-text>
                        </ng-container>
                    </th>
                    <td mat-cell *matCellDef="let row">{{row.TemplateName}}</td>
                </ng-container>

                <ng-container matColumnDef="TemplateDescription">
                    <th mat-header-cell *matHeaderCellDef>
                        <ng-container formGroupName="0">
                            <lgd-text controlName="templateDescriptionFilter" label="Description">
                            </lgd-text>
                        </ng-container>
                    </th>
                    <td mat-cell *matCellDef="let row">{{row.TemplateDescription}}</td>
                </ng-container>

                <ng-container matColumnDef="ControllingFund">
                    <th mat-header-cell *matHeaderCellDef>
                        <ng-container formGroupName="0">
                            <lgd-text controlName="controllingFundFilter" label="Controlling Fund">
                            </lgd-text>
                        </ng-container>
                    </th>
                    <td mat-cell *matCellDef="let row">{{row.ControllingFund}}</td>
                </ng-container>

                <ng-container matColumnDef="JournalTemplateTypeDescription">
                    <th mat-header-cell *matHeaderCellDef>
                        <ng-container formGroupName="0">
                            <lgd-text controlName="templateTypeDescriptionFilter" label="Template Type">
                            </lgd-text>
                        </ng-container>
                    </th>
                    <td mat-cell *matCellDef="let row">{{row.JournalTemplateTypeDescription}}</td>
                </ng-container>

                <ng-container matColumnDef="JournalEntryTypeDescription">
                    <th mat-header-cell *matHeaderCellDef>
                        <ng-container formGroupName="0">
                            <lgd-text controlName="typeDescriptionFilter" label="Journal Entry Type">
                            </lgd-text>
                        </ng-container>
                    </th>
                    <td mat-cell *matCellDef="let row">{{row.JournalEntryTypeDescription}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
                <tr mat-row *matRowDef="let myRowData; columns: columnNames"></tr>
            </table>

            <div *ngIf="!hasData" fxLayout="row" fxLayoutAlign="center start">
                <b>{{message}}</b>
            </div>
        </form>

        <div [formGroup]="formGroup" class="m10">
            <lgd-checkbox controlName="distributionAmount" label="Distribution Amount">
            </lgd-checkbox>
        </div>
    </ng-container>

</mat-dialog-content>

<mat-dialog-actions class="mt10">
    <button mat-button mat-dialog-close telemetry="Submission-CancelJournalTemplate">
        Cancel
    </button>
    <button mat-button [mat-dialog-close]="returnObject" [disabled]="formGroup.invalid" telemetry="Submission-SelectJournalTemplate">
        Select
    </button>
</mat-dialog-actions>